import { render, staticRenderFns } from "./ai_prod_image.vue?vue&type=template&id=3be751f2&scoped=true&"
import script from "./ai_prod_image.vue?vue&type=script&lang=js&"
export * from "./ai_prod_image.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be751f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/host/getorder/api/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3be751f2')) {
      api.createRecord('3be751f2', component.options)
    } else {
      api.reload('3be751f2', component.options)
    }
    module.hot.accept("./ai_prod_image.vue?vue&type=template&id=3be751f2&scoped=true&", function () {
      api.rerender('3be751f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/app/components/catalog/products/product/ai_image/ai_prod_image.vue"
export default component.exports